// Imports Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RecuperarCuentaGuard } from './../../resources/guards/recuperar-cuenta.guard';
import { ContenedorComponent } from './components/contenedor/contenedor.component';
import { MenuComponent } from './components/menu/menu.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';
import { CambiarPassComponent } from './components/cambiar-pass/cambiar-pass.component';
import { AutenticacionComponent } from './components/autenticacion/autenticacion.component';
import { PassFirmaComponent } from './components/pass-firma/pass-firma.component';


const routes: Routes = [   
    {
        path: 'recuperar-cuenta', 
        component: ContenedorComponent,      
        children: [
            { path: '', redirectTo: 'autenticacion', pathMatch:'full' },
            { path: 'autenticacion', component: AutenticacionComponent },            
            { path: 'menu', component: MenuComponent, canActivate: [ RecuperarCuentaGuard ] },
            //{ path: 'confirmacion', component: ConfirmacionComponent,  canActivate: [ RecuperarCuentaGuard ]  },     
            //{ path: 'pass-firma', component: PassFirmaComponent,  canActivate: [ RecuperarCuentaGuard ]  },
            { path: 'cambiar-pass', component: CambiarPassComponent, canActivate: [ RecuperarCuentaGuard ] }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/recuperar-pass-routing.module.ts